import React, { useState, useEffect } from 'react'
import { AlertProvider } from './ghospital-p/context/AlertContext';
import { useAuth } from './ghospital-p/context/AuthContext'
import { Route, Routes } from 'react-router'

import AdminRoutes from './ghospital-p/routes/AdminRoutes'
import AuthRoutes from './ghospital-p/routes/AuthRoutes'

import LogoutPage from './ghospital-p/app/auth/pages/LogoutPage';
import Error404Page from './ghospital-p/app/errorPages/Error404Page';
import Error401Page from './ghospital-p/app/errorPages/Error401Page';
import ChangePasswordPage from './ghospital-p/app/auth/pages/ChangePasswordPage';
import { MqttProvider } from './ghospital-p/context/MqttContext';


function App() {
    const {isLoggedIn,authUser} = useAuth();
    speechSynthesis.getVoices();
    //console.log("authUSerrole", authUser)
    sessionStorage.removeItem("businessInfo");

    // Disable Right Click Start
    /*
    useEffect(() => {
        const handleContextmenu = e => {
            e.preventDefault()
        }
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, [])
    */
    // Disable Right Click End
    
    return (
        <>
        <AlertProvider>
            {isLoggedIn ? 
                <>
                <MqttProvider>
                    { authUser.role == 1 &&
                        <AdminRoutes/>
                    }
                    <Routes>
                        {/*Logout */}
                        <Route path="/auth/logout" element={<LogoutPage/>}></Route>
                        <Route path="/auth/change-password" element={<ChangePasswordPage />}></Route>
                        <Route path="/404" element={<Error404Page/>}></Route>
                        <Route path="/401" element={<Error401Page/>}></Route>
                    </Routes> 
                </MqttProvider>
                </>
                :
                <AuthRoutes/>
            }
        </AlertProvider>
        </>
    )
}
export default App